const deDE = {
    'global': {
        'default': {
            'refresh': 'Aktualisieren',
            'all': 'Alle',
        },
    },
    'TopdataContactLoginSW6': {
        'conversionLog': {
            'module': {
                'name': 'Kundenkonvertierungen',
                'title': 'Kundenkonvertierungen',
                'description': 'Protokoll der Umwandlungen von eigenstaendigen Kundenkonten in B2B-Kontakte',
            },
            'list': {
                'title': 'Kundenkonvertierungen',
                'searchEmailPlaceholder': 'Nach Quell-E-Mail suchen…',
                'filter': {
                    'triggeredBy': 'Ausgeloest durch',
                },
                'column': {
                    'createdAt': 'Datum',
                    'sourceCustomerEmail': 'Quell-E-Mail',
                    'sourceCustomerName': 'Quell-Name',
                    'targetCustomerNumber': 'Ziel-Kundennummer',
                    'ordersTransferred': 'Bestellungen',
                    'contactsMoved': 'Kontakte verschoben',
                    'contactsDeleted': 'Kontakte geloescht',
                    'triggeredBy': 'Ausgeloest durch',
                },
            },
            'triggeredBy': {
                'cli': 'CLI',
                'admin_api': 'Administration',
                'api': 'API (extern)',
            },
        },
    },
};

export default deDE;
